import { createAsyncThunk } from "@reduxjs/toolkit";
import { CategoryCake } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindCategoryCake, GetCategoryCake } from "../../categoryCake/api/interface";

export const findSelectCategoryCake = createAsyncThunk(
  "selectCategoryCake/findSelectCategoryCake",
  async (values: FindCategoryCake, { rejectWithValue }) => {
    try {
      const response = await CategoryCake.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectCategoryCake = createAsyncThunk(
  "selectCategoryCake/searchSelectCategoryCake",
  async (values: FindCategoryCake, { rejectWithValue }) => {
    try {
      const response = await CategoryCake.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getSelectCategoryCake = createAsyncThunk(
  'selectCategoryCake/getSelectCategoryCake',
  async ({ id }: GetCategoryCake, { rejectWithValue }) => {
    try {
      const response = await CategoryCake.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
